const captcha = '/platform/base/captcha';
const login = '/platform/base/login';
const getProjectInfo = '/platform/project/getProjectInfo';
const updateProjectWxCodeUrl = '/platform/project/updateProjectWxCodeUrl';
const getSysUserList = '/platform/sysuser/getSysUserList';
const getAuthorityList = '/platform/authority/getAuthorityList';
const newSysUser = '/platform/sysuser/newSysUser';
const setSysUserInfo = '/platform/sysuser/setSysUserInfo';
const changePassword = '/platform/sysuser/changePassword';
const deleteSysUser = '/platform/sysuser/deleteSysUser';
const getBuildingList = '/platform/project/getBuildingList';
const getFloorList = '/platform/project/getFloorList';
const getBuildingInfo = '/platform/project/getBuildingInfo';
const addBuilding = '/platform/project/addBuilding';
const addFloor = '/platform/project/addFloor';
const addRoom = '/platform/project/addRoom';
const updateBuilding = '/platform/project/updateBuilding';
const updateFloor = '/platform/project/updateFloor';
const updateRoom = '/platform/project/updateRoom';
const delBuilding = '/platform/project/delBuilding';
const delFloor = '/platform/project/delFloor';
const delRoom = '/platform/project/delRoom';
const setRoomOpenScene = '/platform/project/setRoomOpenScene';
const removeRoomOpenScene = '/platform/project/removeRoomOpenScene';
const setRoomCloseScene = '/platform/project/setRoomCloseScene';
const removeRoomCloseScene = '/platform/project/removeRoomCloseScene';
const getRoomInfo = '/platform/project/getRoomInfo';
const syncRoomScene = '/platform/project/syncRoomScene';
const updateRoomDevice = '/platform/project/updateRoomDevice';
const updateFloorDevice = '/platform/project/updateFloorDevice';
const addRoomUnion = '/platform/project/addRoomUnion';
const delRoomUnion = '/platform/project/delRoomUnion';
const getRoomUnion = '/platform/project/getRoomUnion';
const updateRoomUnion = '/platform/project/updateRoomUnion';
const getRoomUnionList = '/platform/project/getRoomUnionList';
const appendRoom2Union = '/platform/project/appendRoom2Union';
const delRoomFromUnion = '/platform/project/delRoomFromUnion';

const addZone = '/platform/mj/addZone';
const delZone = '/platform/mj/delZone';
const updateZone = '/platform/mj/updateZone';
const getZone = '/platform/mj/getZone';
const getZoneList = '/platform/mj/getZoneList';
const addZoneArea = '/platform/mj/addZoneArea';
const delZoneArea = '/platform/mj/delZoneArea';
const updateZoneArea = '/platform/mj/updateZoneArea';
const getZoneArea = '/platform/mj/getZoneArea';
const getZoneAreaList = '/platform/mj/getZoneAreaList';
const addZoneBuilding = '/platform/mj/addZoneBuilding';
const delZoneBuilding = '/platform/mj/delZoneBuilding';
const updateZoneBuilding = '/platform/mj/updateZoneBuilding';
const getZoneBuilding = '/platform/mj/getZoneBuilding';
const getZoneBuildingList = '/platform/mj/getZoneBuildingList';
const addZoneUnit = '/platform/mj/addZoneUnit';
const delZoneUnit = '/platform/mj/delZoneUnit';
const updateZoneUnit = '/platform/mj/updateZoneUnit';
const getZoneUnit = '/platform/mj/getZoneUnit';
const getZoneUnitList = '/platform/mj/getZoneUnitList';
const addZoneRoom = '/platform/mj/addZoneRoom';
const addZoneRooms = '/platform/mj/addZoneRooms';
const delZoneRoom = '/platform/mj/delZoneRoom';
const updateZoneRoom = '/platform/mj/updateZoneRoom';
const getZoneRoom = '/platform/mj/getZoneRoom';
const getZoneRoomList = '/platform/mj/getZoneRoomList';

const showOrHideDevice = '/platform/iot/showOrHideDevice';
const getPidArg = '/platform/iot/queryprofile';
const syncBleGatewayState = '/platform/iot/syncBleGatewayState';
const trigQueryDeviceState = '/platform/iot/trigQueryDeviceState';
const queryDevice = '/platform/iot/queryDevice';
const getPidList = '/platform/iot/getPidList';
const getDeviceList = '/platform/iot/getDeviceList';
const getOnlineInfo = '/platform/iot/getOnlineInfo';
const deviceCtrl = '/platform/iot/deviceCtrl';
const delDevice = '/platform/iot/delDevice';
const updateDevice = '/platform/iot/updateDevice';
const addDevice = '/platform/iot/addDevice';
const getDeviceStatusList = '/platform/iot/getDeviceStatusList';
const lockAllIndoors = '/platform/iot/lockAllIndoors';
const getVGroupDeviceList = '/platform/iot/getVGroupDeviceList';
const addDevToVGroup = '/platform/iot/addDevToVGroup';
const updateVGroupDevice = '/platform/iot/updateVGroupDevice';

const getTimerList = '/platform/timer/getTimerList';
const addTimer = '/platform/timer/addTimer';
const delTimer = '/platform/timer/delTimer';
const updateTimer = '/platform/timer/updateTimer';
const enableTimer = '/platform/timer/enableTimer';
const getSceneList = '/platform/scene/getSceneList';
const newScene = '/platform/scene/newScene';
const updateScene = '/platform/scene/updateScene';
const replaceSceneItem = '/platform/scene/replaceSceneItem';
const sceneExecute = '/platform/scene/sceneExecute';
const delScene = '/platform/scene/delScene';

const getUserMgrLogList = '/platform/log/getUserMgrLogList';
const getDeviceMgrLogList = '/platform/log/getDeviceMgrLogList';
const getSceneExeLogList = '/platform/log/getSceneExeLogList';
const getTimerMgrLogList = '/platform/log/getTimerMgrLogList';
const today = '/platform/airenergy/today';
const curWeek = '/platform/airenergy/curWeek';
const curMonth = '/platform/airenergy/curMonth';
const curYear = '/platform/airenergy/curYear';

const addAuto = '/platform/auto/addAuto';
const enableAuto = '/platform/auto/enableAuto';
const updateAuto = '/platform/auto/updateAuto';
const getAutoList = '/platform/auto/getAutoList';
const delAuto = '/platform/auto/delAuto';
const getAutoTriggerList = '/platform/auto/getAutoTriggerList';
const addAutoTrigger = '/platform/auto/addAutoTrigger';
const delAutoTrigger = '/platform/auto/delAutoTrigger';
const updateAutoTrigger = '/platform/auto/updateAutoTrigger';
const getAutoConditionList = '/platform/auto/getAutoConditionList';
const addAutoCondition = '/platform/auto/addAutoCondition';
const delAutoCondition = '/platform/auto/delAutoCondition';
const updateAutoCondition = '/platform/auto/updateAutoCondition';
const getAutoExceptionList = '/platform/auto/getAutoExceptionList';
const addAutoException = '/platform/auto/addAutoException';
const delAutoException = '/platform/auto/delAutoException';
const updateAutoException = '/platform/auto/updateAutoException';

const getActivityList = '/platform/service/getActivityList';
const newActivity = '/platform/service/newActivity';
const delActivity = '/platform/service/delActivity';
const changeActivity = '/platform/service/changeActivity';
const updateActivity = '/platform/service/updateActivity';
const addActivityImages = '/platform/service/addActivityImages';
const replaceActivityImages = '/platform/service/replaceActivityImages';
const changeActivityState = '/platform/service/changeActivityState';
const uploadFile = '/platform/file/uploadFile';
const getFeedbackList = '/platform/service/getFeedbackList';
const getFeedbackStatis = '/platform/service/getFeedbackStatis';
const queryFeedback = '/platform/service/queryFeedback';
const processFeedback = '/platform/service/processFeedback';
const getNotifyList = '/platform/service/getNotifyList';
const newNotify = '/platform/service/newNotify';
const delNotify = '/platform/service/delNotify';
const changeNotify = '/platform/service/changeNotify';
const updateNotify = '/platform/service/updateNotify';
const changeNotifyState = '/platform/service/changeNotifyState';
const notifyStatis = '/platform/service/notifyStatis';
const getBannerList = '/platform/service/getBannerList';
const newBanner = '/platform/service/newBanner';
const delBanner = '/platform/service/delBanner';
const updateBannerOrder = '/platform/service/updateBannerOrder';
const exchangeBannerSort = '/platform/service/exchangeBannerSort';
const exchangeNotifySort = '/platform/service/exchangeNotifySort';
const changeBanner = '/platform/service/changeBanner';
const updateBanner = '/platform/service/updateBanner';
const postBanner = '/platform/service/postBanner';
const getRoomList = '/platform/project/getRoomList';
const updateRoomAppointInfo = '/platform/project/updateRoomAppointInfo';
const getAppointTotal = '/platform/service/getAppointTotal';
const getActivityEvaluateList = '/platform/service/getActivityEvaluateList';
const getActivityEvaluateStatis = '/platform/service/getActivityEvaluateStatis';
const getAppointDetailList = '/platform/service/getAppointDetailList';
const getAppointList = '/platform/service/getAppointList';
const getAppointRatio = '/platform/service/getAppointRatio';
const getAppointInOneDay = '/platform/service/getAppointInOneDay';
const getHsUserList = '/platform/mj/getUserList';
const addHsUser = '/platform/mj/addUser';
const upHsdateUser = '/platform/mj/updateUser';
const delHsUser = '/platform/mj/delUser';
const approveUser = '/platform/mj/approveUser';
const getMarketAppointList = '/platform/market/getMarketAppointList';
const getAppointSetting = '/platform/market/getAppointSetting';
const editAppointSetting = '/platform/market/editAppointSetting';
const newAppointSetting = '/platform/market/newAppointSetting';
const newInterestingProduct = '/platform/market/newInterestingProduct';
const newAppointService = '/platform/service/newAppointService';
const editAppointService = '/platform/service/editAppointService';
const delAppointService = '/platform/service/delAppointService';
const getAppointServiceList = '/platform/service/getAppointServiceList';
const newInterestingDrink = '/platform/market/newInterestingDrink';
const delInterestingProduct = '/platform/market/delInterestingProduct';
const delInterestingDrink = '/platform/market/delInterestingDrink';
const changeInterestingProduct = '/platform/market/editInterestingProduct';
const changeInterestingDrink = '/platform/market/editInterestingDrink';
const newInvalidTimeRange = '/platform/market/newInvalidTimeRange';
const editInvalidTimeRange = '/platform/market/editInvalidTimeRange';
const newValidTimeRange = '/platform/market/newValidTimeRange';
const editValidTimeRange = '/platform/market/editValidTimeRange';
const delValidTimeRange = '/platform/market/delValidTimeRange';
const delInvalidTimeRange = '/platform/market/delInvalidTimeRange';
const approveMarketAppoint = '/platform/market/approveMarketAppoint';
const delMarketAppoint = '/platform/market/delMarketAppoint';
const getAppointCareList = '/platform/service/getAppointCareList';
const editAppointCare = '/platform/service/editAppointCare';
const newAppointCare = '/platform/service/newAppointCare';
const delAppointCare = '/platform/service/delAppointCare';
const addAppoint = '/platform/service/addAppoint';
const addAppointBySys = '/platform/service/addAppointBySys';
const getGoodsList = '/platform/mall/getGoodsList';
const getGoods = '/platform/mall/getGoods';
const newGoods = '/platform/mall/newGoods';
const updateGoods = '/platform/mall/updateGoods';
const getGoodsTypeList = '/platform/mall/getGoodsTypeList';
const getGoodsStateList = '/platform/mall/getGoodsStateList';
const changeGoodsState = '/platform/mall/changeGoodsState';
const cancelRoomAppointGoods = '/platform/mall/cancelRoomAppointGoods';
const setRoomAppointGoods = '/platform/mall/setRoomAppointGoods';
const delGoods = '/platform/mall/delGoods';
const addGoodsType = '/platform/mall/addGoodsType';
const delGoodsType = '/platform/mall/delGoodsType';
const getGoodsCommentList = '/platform/mall/getGoodsCommentList';
const getGoodsCommentLevelList = '/platform/mall/getGoodsCommentLevelList';
const getOrderStatusList = '/platform/mall/getOrderStatusList';
const getUserOrder = '/platform/mall/getUserOrder';
const getUserOrderList = '/platform/mall/getUserOrderList';
const getOrderStatisticList = '/platform/mall/getOrderStatisticList';
const getOrderStatistic2List = '/platform/mall/getOrderStatistic2List';
const refund = '/platform/mallwxpay/refund';

export default {
  ip:'http://127.0.0.1:9080',
  websocketUrl:'wss://localhost:12000',
  getActivityList:getActivityList, /*活动*/
  delActivity:delActivity,
  newActivity:newActivity,
  changeActivity:changeActivity,
  updateActivity:updateActivity,
  addActivityImages:addActivityImages,
  replaceActivityImages:replaceActivityImages,
  changeActivityState:changeActivityState,
  uploadFile:uploadFile,
  getFeedbackList:getFeedbackList, /*意见反馈*/
  getFeedbackStatis:getFeedbackStatis, /*意见反馈*/
  queryFeedback:queryFeedback, /*意见反馈*/
  processFeedback:processFeedback, /*意见反馈*/
  getNotifyList:getNotifyList, /*公告*/
  newNotify:newNotify,
  delNotify:delNotify,
  changeNotify:changeNotify,
  updateNotify:updateNotify,
  changeNotifyState:changeNotifyState,
  notifyStatis:notifyStatis,
  getBannerList:getBannerList, /*轮播图*/
  newBanner:newBanner,
  delBanner:delBanner,
  updateBannerOrder:updateBannerOrder,
  exchangeBannerSort:exchangeBannerSort,
  exchangeNotifySort:exchangeNotifySort,
  changeBanner:changeBanner,
  updateBanner:updateBanner,
  postBanner:postBanner,
  getRoomList:getRoomList, /*房间*/
  updateRoomAppointInfo:updateRoomAppointInfo, /*修改房间信息*/
  getActivityEvaluateStatis:getActivityEvaluateStatis, /*活动评价*/
  getActivityEvaluateList:getActivityEvaluateList, /*活动评价列表*/
  getAppointTotal:getAppointTotal, /*活动管理*/
  getAppointDetailList:getAppointDetailList, /*预约反馈*/
  getAppointList:getAppointList, /*预约列表*/
  getAppointRatio:getAppointRatio, /*活动管理*/
  getAppointInOneDay:getAppointInOneDay, /*活动管理*/
  getHsUserList:getHsUserList, /*获取用户信息*/
  addHsUser:addHsUser,
  upHsdateUser:upHsdateUser,
  delHsUser:delHsUser,
  approveUser:approveUser,
  getMarketAppointList:getMarketAppointList, /*预约列表*/
  getAppointSetting:getAppointSetting, /*获取预约设置*/
  editAppointSetting:editAppointSetting, /*修改预约设置*/
  newAppointSetting:newAppointSetting, /*修改预约设置*/
  newAppointService:newAppointService, /*添加服务*/
  editAppointService:editAppointService, /*添加服务*/
  delAppointService:delAppointService, /*添加服务*/
  getAppointServiceList:getAppointServiceList, /*获取服务列表*/

  newInterestingProduct:newInterestingProduct, /*添加产品*/
  newInterestingDrink:newInterestingDrink, /*添加同行人*/
  delInterestingProduct:delInterestingProduct, /*删除产品*/
  delInterestingDrink:delInterestingDrink, /*删除同行人*/
  changeInterestingProduct:changeInterestingProduct, /*修改产品*/
  changeInterestingDrink:changeInterestingDrink, /*修改同行人*/
  newInvalidTimeRange:newInvalidTimeRange, /*删除同行人*/
  editInvalidTimeRange:editInvalidTimeRange, /*删除同行人*/
  newValidTimeRange:newValidTimeRange, /*同行人*/
  editValidTimeRange:editValidTimeRange, /*删除同行人*/
  delValidTimeRange:delValidTimeRange, /*删除同行人*/
  delInvalidTimeRange:delInvalidTimeRange, /*删除同行人*/
  approveMarketAppoint:approveMarketAppoint, /*删除同行人*/
  delMarketAppoint:delMarketAppoint, /*删除同行人*/
  getAppointCareList:getAppointCareList, /*获取预约通用设置*/
  newAppointCare:newAppointCare, /*添加预约通用设置*/
  editAppointCare:editAppointCare, /*修改预约通用设置*/
  delAppointCare:delAppointCare, /*删除预约通用设置*/
  addAppoint:addAppoint, /*添加预约*/
  addAppointBySys:addAppointBySys, /*代客预约*/

  getGoodsList:getGoodsList,/*商品列表*/
  getGoods:getGoods,/*商品列表*/
  newGoods:newGoods,/*新增商品*/
  updateGoods:updateGoods,/*新增商品*/
  getGoodsTypeList:getGoodsTypeList,/*商品列表*/
  getGoodsStateList:getGoodsStateList,/*商品列表*/
  changeGoodsState:changeGoodsState,/*修改商品状态*/
  cancelRoomAppointGoods:cancelRoomAppointGoods,/*修改商品状态*/
  setRoomAppointGoods:setRoomAppointGoods,/*修改商品状态*/
  delGoods:delGoods,/*删除商品*/
  addGoodsType:addGoodsType,/*新增类型*/
  delGoodsType:delGoodsType,/*删除类型*/
  getGoodsCommentList:getGoodsCommentList,/*获取评价*/
  getGoodsCommentLevelList:getGoodsCommentLevelList,/*获取评价等级*/
  getOrderStatusList:getOrderStatusList,/*订单状态*/
  getUserOrder:getUserOrder,/*订单详情*/
  getUserOrderList:getUserOrderList,/*订单列表*/
  getOrderStatisticList:getOrderStatisticList,/*订单统计*/
  getOrderStatistic2List:getOrderStatistic2List,/*财务对账*/
  refund:refund,/*退款*/

  captcha:captcha, /*验证码*/
  login:login, /*登录*/
  getProjectInfo:getProjectInfo, /*登录*/
  updateProjectWxCodeUrl:updateProjectWxCodeUrl, /*登录*/
  getAuthorityList:getAuthorityList, /*获取角色信息*/
  getSysUserList:getSysUserList, /*获取用户信息*/
  newSysUser:newSysUser, /*新增用户*/
  setSysUserInfo:setSysUserInfo, /*修改用户信息*/
  changePassword:changePassword, /*重置密码*/
  deleteSysUser:deleteSysUser, /*删除用户*/
  getBuildingList:getBuildingList, /*获取全部区域*/
  getFloorList:getFloorList, /*获取全部区域*/
  getBuildingInfo:getBuildingInfo, /*获取全部区域*/
  addBuilding:addBuilding, /*添加区域*/
  addFloor:addFloor, /*添加楼层*/
  addRoom:addRoom, /*添加房间*/
  updateBuilding:updateBuilding, /*修改楼栋名称*/
  updateFloor:updateFloor, /*修改楼栋名称*/
  updateRoom:updateRoom, /*修改房间名称*/
  delBuilding:delBuilding, /*删除楼栋*/
  delFloor:delFloor, /*删除楼层*/
  delRoom:delRoom, /*删除房间*/
  setRoomOpenScene:setRoomOpenScene, /*同步开门场景*/
  removeRoomOpenScene:removeRoomOpenScene, /*移除开门场景*/
  setRoomCloseScene:setRoomCloseScene, /*同步关门场景*/
  removeRoomCloseScene:removeRoomCloseScene, /*移除关门场景*/
  getRoomInfo:getRoomInfo, /*获取房间信息*/
  syncRoomScene:syncRoomScene, /*同步房间场景*/
  updateRoomDevice:updateRoomDevice, /*房间更新设备*/
  updateFloorDevice:updateFloorDevice, /*楼层更新设备*/
  addRoomUnion:addRoomUnion, /*新增房间分组*/
  delRoomUnion:delRoomUnion, /*删除房间分组*/
  getRoomUnion:getRoomUnion, /*获取房间分组信息*/
  updateRoomUnion:updateRoomUnion, /*升级房间分组信息*/
  getRoomUnionList:getRoomUnionList, /*获取房间分组列表*/
  appendRoom2Union:appendRoom2Union, /*添加房间分组关联*/
  delRoomFromUnion:delRoomFromUnion, /*删除房间分组关联*/
  addZone:addZone, /*添加社区*/
  delZone:delZone, /*删除社区*/
  updateZone:updateZone, /*修改社区*/
  getZone:getZone, /*查看社区*/
  getZoneList:getZoneList, /*查看社区list*/
  addZoneArea:addZoneArea, /*添加片区*/
  delZoneArea:delZoneArea, /*删除片区*/
  updateZoneArea:updateZoneArea, /*修改片区*/
  getZoneArea:getZoneArea, /*查看片区*/
  getZoneAreaList:getZoneAreaList, /*查看片区list*/
  addZoneBuilding:addZoneBuilding, /*添加楼栋*/
  delZoneBuilding:delZoneBuilding, /*删除楼栋*/
  updateZoneBuilding:updateZoneBuilding, /*修改楼栋*/
  getZoneBuilding:getZoneBuilding, /*查看楼栋*/
  getZoneBuildingList:getZoneBuildingList, /*查看楼栋list*/
  addZoneUnit:addZoneUnit, /*添加单元*/
  delZoneUnit:delZoneUnit, /*删除单元*/
  updateZoneUnit:updateZoneUnit, /*修改单元*/
  getZoneUnit:getZoneUnit, /*查看单元*/
  getZoneUnitList:getZoneUnitList, /*查看单元list*/
  addZoneRoom:addZoneRoom, /*添加房间*/
  addZoneRooms:addZoneRooms, /*添加房间列表*/
  delZoneRoom:delZoneRoom, /*删除房间*/
  updateZoneRoom:updateZoneRoom, /*修改房间*/
  getZoneRoom:getZoneRoom, /*查看房间*/
  getZoneRoomList:getZoneRoomList, /*查看房间list*/

  showOrHideDevice:showOrHideDevice, /*设备列表显示隐藏*/
  getUserMgrLogList:getUserMgrLogList, /*更新用户日志*/
  getDeviceMgrLogList:getDeviceMgrLogList, /*更新用户日志*/
  getSceneExeLogList:getSceneExeLogList, /*更新用户日志*/
  getTimerMgrLogList:getTimerMgrLogList, /*更新用户日志*/
  today:today, /*更新用户日志*/
  curWeek:curWeek, /*更新用户日志*/
  curMonth:curMonth, /*更新用户日志*/
  curYear:curYear, /*更新用户日志*/

  getPidArg:getPidArg, /*获取设备类型*/
  queryDevice:queryDevice, /*触发蓝牙设备状态上报*/
  trigQueryDeviceState:trigQueryDeviceState, /*触发蓝牙设备状态上报*/
  syncBleGatewayState:syncBleGatewayState, /*获取设备类型*/
  getPidList:getPidList, /*获取设备类型*/
  getDeviceList:getDeviceList, /*获取设备列表*/
  getOnlineInfo:getOnlineInfo, /*获取设备状态*/
  deviceCtrl:deviceCtrl, /*设备控制*/
  delDevice:delDevice, /*删除设备*/
  updateDevice:updateDevice, /*修改设备信息*/
  addDevice:addDevice, /*添加设备*/
  lockAllIndoors:lockAllIndoors, /*设备锁定*/
  getDeviceStatusList:getDeviceStatusList, /*获取设备状态列表*/
  getTimerList:getTimerList, /*获取定时列表*/
  getVGroupDeviceList:getVGroupDeviceList, /*获取设备组*/
  addDevToVGroup:addDevToVGroup, /*添加设备组*/
  updateVGroupDevice:updateVGroupDevice, /*更新设备组*/

  addTimer:addTimer, /*添加定时*/
  delTimer:delTimer, /*删除定时*/
  updateTimer:updateTimer, /*修改定时*/
  enableTimer:enableTimer, /*修改定时开关*/
  getSceneList:getSceneList, /*获取场景列表*/
  newScene:newScene, /*添加场景*/
  updateScene:updateScene, /*更新场景*/
  replaceSceneItem:replaceSceneItem, /*更新场景*/
  sceneExecute:sceneExecute, /*执行场景*/
  delScene:delScene, /*删除场景*/
  addAuto:addAuto, /*添加联动*/
  enableAuto:enableAuto, /*联动开关*/
  updateAuto:updateAuto, /*更新联动*/
  getAutoList:getAutoList, /*获取联动*/
  delAuto:delAuto, /*删除联动*/
  getAutoTriggerList:getAutoTriggerList, /*查询触发条件*/
  addAutoTrigger:addAutoTrigger, /*添加触发条件*/
  updateAutoTrigger:updateAutoTrigger, /*更新触发条件*/
  delAutoTrigger:delAutoTrigger, /*删除触发条件*/
  getAutoConditionList:getAutoConditionList, /*查询约束条件*/
  addAutoCondition:addAutoCondition, /*添加约束条件*/
  updateAutoCondition:updateAutoCondition, /*更新约束条件*/
  delAutoCondition:delAutoCondition, /*删除约束条件*/
  getAutoExceptionList:getAutoExceptionList, /*查询约束条件-时段*/
  addAutoException:addAutoException, /*添加约束条件-时段*/
  updateAutoException:updateAutoException, /*更新约束条件-时段*/
  delAutoException:delAutoException, /*删除约束条件-时段*/

  errors:{
    504:"服务器无法连接",404:"服务器无法连接",403:"权限不足，请联管理员",401:"尚未登录，请登录！",40208:"验证码错误"
  }
};

// export default ip;



// WEBPACK FOOTER //
// ./src/config/urls.js